import { render, staticRenderFns } from "./UserNotesBox.vue?vue&type=template&id=30ea6c12"
import script from "./UserNotesBox.vue?vue&type=script&lang=js"
export * from "./UserNotesBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports